import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "remove", "list", "template"]

  connect() {
    if (!this.hasItemTarget) this.add()
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RESOURCE/g, new Date().getTime().toString())
    this.listTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    this.itemTargets
      .find(item => item.contains(event.target))
      .remove()
  }

  itemTargetConnected() {
    this.updateRemoval()
  }

  itemTargetDisconnected() {
    this.updateRemoval()
  }

  updateRemoval() {
    this.removeTarget.toggleAttribute("disabled", this.itemTargets.length === 1)
  }
}
